export interface SurveyDto {
  details: SurveyDetailDto;
  groups: SurveyGroupDto[];
}

export interface SurveyDetailDto {
  className: string;
  format: string;
  sessionStartTime: number;
  teacherName: string;
}

export interface SurveyGroupDto {
  active: boolean;
  description: string;
  groupType: string;
  id: number;
  name: string;
  questions: SurveyQuestionDto[];
  sequence: number;
  subGroup: boolean;
  type: string;
}

export interface SurveyQuestionDto {
  active: boolean;
  answer: string;
  group;
  id: number;
  quantity;
  question: string;
  sequence: number;
  targetGroupId;
  type: string;
  options: SurveyOptionDto[];
}

export enum SurveyQuestionType {
  IMAGE = 'image',
  TEXT = 'TEXT',
  TOP = 'top',
  MULTI = 'multi',
  SINGLE = 'single',
}

export interface SurveyOptionDto {
  id: number;
  question;
  questionGroup;
  questionOption: string;
  selected: boolean;
  sequence: number;
  topAnswer;
  type: string;
}

export enum SurveyOptionType {
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  TOP = 'top',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/survey-dto.ts